export default __webpack_public_path__ + "static/media/confused.e96fa351.png";